import { render } from "./StaffDetailsManager.vue?vue&type=template&id=e7a73bb6&scoped=true"
import script from "./StaffDetailsManager.vue?vue&type=script&lang=js"
export * from "./StaffDetailsManager.vue?vue&type=script&lang=js"

import "./StaffDetailsManager.vue?vue&type=style&index=0&id=e7a73bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7a73bb6"]])

export default __exports__